import searchActionTypes from "./search.types";

export const showSearchDropdown = () => ({
  type: searchActionTypes.SHOW_SEARCH_DROPDOWN,
});

export const hideSearchDropdown = () => ({
  type: searchActionTypes.HIDE_SEARCH_DROPDOWN,
});
